import React, { useState } from 'react';
import Layout from '../Layout';
import '../CustomAssets/Css/Pages/Services.css';
import { NavLink } from 'react-router-dom';

export default function Services() {

  const servicesData = [
    {
      category: "Digital Financial Services",
      services: [
        {
          title: "AEPS",
          description: "Aadhaar Enabled Payment System for cash withdrawal & balance check.",
          image: "/CustomAssets/Images/Pages/Services/img1.svg"
        },
        {
          title: "Train Ticket",
          description: "Book train tickets easily with our platform.",
          image: "/CustomAssets/Images/Pages/Services/img10.svg"
        },
        {
          title: "Flight Ticket",
          description: "Hassle-free domestic & international flight booking.",
          image: "/CustomAssets/Images/Pages/Services/img9.svg"
        },
        {
          title: "Money Transfer",
          description: "Instant and secure money transfer services.",
          image: "/CustomAssets/Images/Pages/Services/img13.svg"
        },
        {
          title: "Money Withdraw",
          description: "Withdraw cash from banking outlets using AEPS.",
          image: "/CustomAssets/Images/Pages/Services/img8.svg"
        },
        {
          title: "New PAN Card",
          description: "Apply for a new PAN card digitally.",
          image: "/CustomAssets/Images/Pages/Services/img14.svg"
        },
        {
          title: "PAN Card Correction",
          description: "Update or correct PAN card details.",
          image: "/CustomAssets/Images/Pages/Services/img15.svg"
        }
      ]
    },
    {
      category: "Design & Branding",
      services: [
        {
          title: "Web Designing",
          description: "Modern responsive websites tailored to your needs.",
          image: "/CustomAssets/Images/Pages/Services/img3.svg"
        },
        {
          title: "Logo Designs",
          description: "Creative and professional logo designs.",
          image: "/CustomAssets/Images/Pages/Services/img20.svg"
        },
        {
          title: "Brand Design",
          description: "Creative and professional logo designs.",
          image: "/CustomAssets/Images/Pages/Services/img19.svg"
        },
      ]
    },
    {
      category: "CSP Provider Services",
      services: [
        {
          title: "BOB CSP",
          description: "Bank of Baroda CSP Services.",
          image: "/CustomAssets/Images/Pages/Services/img12.svg"
        },
        {
          title: "NSDL CSP",
          description: "NSDL CSP support and services.",
          image: "/CustomAssets/Images/Pages/Services/img2.svg"
        },
        {
          title: "SBI CSP",
          description: "State Bank of India CSP facilities.",
          image: "/CustomAssets/Images/Pages/Services/img21.svg"
        },
        {
          title: "Suryoday Small Finance Bank CSP",
          description: "CSP services for Suryoday Small Finance Bank.",
          image: "/CustomAssets/Images/Pages/Services/img4.svg"
        }
      ]
    },
    {
      category: "Software Solutions",
      services: [
        {
          title: "AEPS Service Portal",
          description: "AEPS portal for partners.",
          link: "https://partner.biznext.in/bo",
          image: "/CustomAssets/Images/Pages/Services/img22.svg"
        },
        {
          title: "CRM Software",
          description: "Design bank-wise custom branding logos.",
          image: "/CustomAssets/Images/Pages/Services/img23.svg"
        }
      ]
    },
    {
      category: "CIBIL Consultancy",
      services: [
        {
          title: "CIBIL Score Update",
          description: "Get your CIBIL score updated with consultancy support.",
          image: "/CustomAssets/Images/Pages/Services/img6.svg"
        },
        {
          title: "CIBIL Score Check",
          description: "Check your CIBIL score from multiple agencies.",
          image: "/CustomAssets/Images/Pages/Services/img11.svg",
          extraDetails: ["TransUnion", "Equifax", "Experian"]
        }
      ]
    }
  ];
  const [activeService, setActiveService] = useState(1);


  const handleTabClick = (tabKey) => {
    setActiveService(tabKey);

    const section = document.getElementById(`section-${tabKey}`);
    if (section) {
      const headerOffset = 150;
      const elementPosition = section.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };


  return (
    <Layout>
      <div className="tp-page-area sec-mar">
        <div className="container-fluid custom-container">
          <div className="row">
            <div className="col-xl-12">
              <div className="tp-page-content">
                <div className="tp-page-post">
                  <div className="elementor elementor-49">

                    <section className="careers_section section">
                      <div className="container">
                        <div className="row justify-content-center">
                          <div className="col-12 col-lg-12 col-xxl-12">
                            <div className="section__header text-center">
                              <span className="sub-title section__header-sub-title headingFour wow fadeInDown txt_clr">
                                <img decoding="async"
                                  src="theme_assets/assets/themes/assets/images/title_vector.png"
                                  alt="Image" /> Services
                              </span>
                              <h2 className="title section__header-title wow fadeInUp">
                                Choose Our Services to Power Your Business Growth <br />and Unlock New Opportunities
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>

                    <div className='rpt_Services_wrapper'>
                      <div className='rpt_Services'>
                        <div className='container' >

                          <div className='col-md-12'>
                            <div className='rpt_h'>
                              {servicesData.map((block, idx) => (
                                <h6
                                  key={idx}
                                  className={`rpt_hd ${activeService === idx ? 'active_rpt' : ''}`}
                                  onClick={() => handleTabClick(idx)}
                                  style={{ cursor: "pointer" }}
                                >
                                  {block.category}
                                </h6>
                              ))}
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>

                    {servicesData.map((block, idx) => (
                      <section key={idx} id={`section-${idx}`} className="feature feature--tertiary section careers_sectionCards">
                        <div className="container">
                          <h3 className="mb-4 text-center">{block.category}</h3>
                          <div className="row g-3 g-sm-2 g-md-3 g-xxl-4">
                            {block.services.map((service, index) => (
                              <div className="col-12 col-sm-6 col-xl-4" key={index}>
                                <div className="cus_card card card--custom gap-0 cus_align wow fadeInUp crd_hvr cardHoverBtnClr cstm_plan_card serviceCardMainDiv">

                                  <div className="card-img-top text-center serviceCardMain">
                                    <img className="service-card-img" src={service.image} alt={service.title} />
                                  </div>

                                  <div className='ServiceplanCardUpper'>
                                    <div className="card__content cus_cont crd_txt_clr">
                                      <h4 className="card_title">
                                        {service.link ? (
                                          <a href={service.link} target="_blank" rel="noreferrer" className="cus_title_link">
                                            {service.title}
                                          </a>
                                        ) : (
                                          <NavLink to={"/services"} className="cus_title_link">
                                            {service.title}
                                          </NavLink>
                                        )}
                                      </h4>
                                      <p className="fs-small">{service.description}</p>

                                      {service.extraDetails && (
                                        <ul className="fs-small mt-2">
                                          {service.extraDetails.map((detail, i) => (
                                            <li key={i}>{detail}</li>
                                          ))}
                                        </ul>
                                      )}
                                    </div>
                                  </div>

                                  <div>
                                    <div className="btn-cta">
                                      {service.link ? (
                                        <a href={service.link} target="_blank" rel="noreferrer" className="btn_clr serviceChoiceBtn">Visit</a>
                                      ) : (
                                        <NavLink to={"/contactUs"} className="btn_clr serviceChoiceBtn">Choose</NavLink>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </section>
                    ))}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
